import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';

// Add onToggleSidebar and isSidebarOpen props
const Navbar = ({ onToggleSidebar, isSidebarOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-navbar">
      {/* Hamburger Menu Button - Only visible on mobile */}
      <button 
        className="hamburger-btn"
        onClick={onToggleSidebar}
        aria-label="Toggle menu"
      >
        <span className={`hamburger-icon ${isSidebarOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      <div className="navbar-user-info">
        <h2 className="navbar-welcome">
          Welcome back, {user?.name}!
        </h2>
      </div>
      
      <div className="navbar-actions">
        <span className="navbar-email">
          {user?.email}
        </span>
        <Button variant="secondary" size="sm" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Navbar;